import UserInfo from './UserInfo.jsx';

export {UserInfo}



// WEBPACK FOOTER //
// ./components/partials/userinfo/index.js